import { atom } from "recoil";

 // 選択できる医療機関リスト
export const courceClinicState = atom({
  key: "courceClinicState",
  default: null,
});